/* ============================================================================
 * Movatic WMS — Frontend | CesarFilho 932048016
 * Arquivo: src/components/ui/input.tsx
 * ========================================================================== */
import * as React from "react";

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
    ({ className = "", ...props }, ref) => (
        <input
            ref={ref}
            className={`w-full rounded-md border border-slate-700 bg-[#0b0f1a] px-3 py-2 text-sm text-white outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
            {...props}
        />
    )
);
Input.displayName = "Input";
export default Input;
